// Per-warehouse stock view + ledger
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Warehouse as WhIcon, Filter, History } from "lucide-react";
import { api } from "../../../lib/auth";
import { Card, PageHeader, Field, Select } from "./_shared";

export default function StockByWarehouse() {
  const { subdomain } = useParams();
  const [tab, setTab] = useState("stock");
  const [rows, setRows] = useState([]);
  const [ledger, setLedger] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [whFilter, setWhFilter] = useState("");
  useEffect(() => { api.get("/t/warehouses").then((r) => setWarehouses(r.data)); }, []);
  useEffect(() => {
    const params = whFilter ? { params: { warehouse_id: whFilter } } : {};
    api.get("/t/stock-by-warehouse", params).then((r) => setRows(r.data));
    api.get("/t/stock-ledger", params).then((r) => setLedger(r.data));
  }, [whFilter]);
  return (
    <div data-testid="stock-by-wh-page" className="p-6 lg:p-8">
      <PageHeader title="Stock by Warehouse" breadcrumb="Products / Stock by Warehouse" />
      <div className="flex gap-2 mb-4 items-center">
        <button onClick={() => setTab("stock")} data-testid="tab-stock" className={`px-4 py-2 rounded-xl text-sm font-bold ${tab === "stock" ? "bg-[#1FA868] text-white" : "bg-white border border-black/10"}`}>Current Stock</button>
        <button onClick={() => setTab("ledger")} data-testid="tab-ledger" className={`px-4 py-2 rounded-xl text-sm font-bold ${tab === "ledger" ? "bg-[#1FA868] text-white" : "bg-white border border-black/10"}`}>Movement Ledger</button>
        <div className="ml-auto w-56">
          <Select value={whFilter} onChange={setWhFilter} options={[{ value: "", label: "All warehouses" }, ...warehouses.map((w) => ({ value: w.id, label: w.name }))]} testid="wh-filter" />
        </div>
      </div>
      {tab === "stock" ? (
        <Card>
          <table className="w-full text-sm">
            <thead className="bg-[#FAFBFB] text-black/55 text-[11px] uppercase">
              <tr><th className="text-left p-3.5">Product</th><th className="text-left p-3.5">Warehouse</th><th className="text-right p-3.5">Quantity</th></tr>
            </thead>
            <tbody className="divide-y divide-black/5">
              {rows.filter((r) => r.qty !== 0).map((r) => (
                <tr key={`${r.product_id}-${r.warehouse_id}`} className="hover:bg-[#FAFBFB]">
                  <td className="p-3.5 font-semibold">{r.product_name}</td>
                  <td className="p-3.5">{r.warehouse_name}</td>
                  <td className={`p-3.5 text-right font-bold ${r.qty < 0 ? "text-rose-600" : r.qty < 10 ? "text-amber-600" : "text-emerald-700"}`}>{r.qty}</td>
                </tr>
              ))}
              {!rows.filter((r) => r.qty !== 0).length && <tr><td colSpan={3} className="p-10 text-center text-black/45">No stock movements yet — create a transfer to populate per-warehouse balances.</td></tr>}
            </tbody>
          </table>
        </Card>
      ) : (
        <Card>
          <table className="w-full text-sm">
            <thead className="bg-[#FAFBFB] text-black/55 text-[11px] uppercase">
              <tr><th className="text-left p-3.5">Date</th><th className="text-left p-3.5">Product</th><th className="text-left p-3.5">Warehouse</th><th className="text-left p-3.5">Reason</th><th className="text-left p-3.5">Reference</th><th className="text-right p-3.5">Δ Qty</th></tr>
            </thead>
            <tbody className="divide-y divide-black/5">
              {ledger.map((r) => (
                <tr key={r.id} className="hover:bg-[#FAFBFB]">
                  <td className="p-3.5">{r.date}</td>
                  <td className="p-3.5 font-semibold">{r.product_name}</td>
                  <td className="p-3.5">{r.warehouse_name}</td>
                  <td className="p-3.5"><span className="text-[10px] font-bold uppercase px-2 py-0.5 rounded bg-black/5">{r.reason}</span></td>
                  <td className="p-3.5 font-mono text-xs">{r.reference || "—"}</td>
                  <td className={`p-3.5 text-right font-bold ${r.qty_delta >= 0 ? "text-emerald-700" : "text-rose-600"}`}>{r.qty_delta >= 0 ? "+" : ""}{r.qty_delta}</td>
                </tr>
              ))}
              {!ledger.length && <tr><td colSpan={6} className="p-10 text-center text-black/45">No ledger entries yet</td></tr>}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
